import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TAligner } from './models';

export const Aligner: FC<React.PropsWithChildren<TAligner>> = props => {
    const { align = 'center', children, className, styles, ...rest } = props;

    return (
        <div className={cn(styles.external, styles[align], className)} {...rest}>
            {children}
        </div>
    );
};
